const release = '0.13.5'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js